export const FirebaseConfig = {
	"projectId": "dash-drop",
	"appId": "1:550300557012:web:5956173a541ede319ae541",
	"databaseURL": "https://dash-drop-default-rtdb.firebaseio.com",
	"storageBucket": "dash-drop.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyD5d3jsK70-RqNcKo2Z8GViY9xnK0PWNRQ",
	"authDomain": "dash-drop-3c11c.firebaseapp.com",
	"messagingSenderId": "550300557012",
	"measurementId": "G-XP6G29NRGR"
};